module.exports = __webpack_public_path__ + "static/joseph-barrientos-oQl0eVYd_n8-unsplash-3dd2ab53f69638b7f60592302dbefa66.jpg";